import React, { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import SelectEventItemView from './SelectEventItemView';

import { sendCustomSentryBreadcrumb } from '../../../../../../helpers/sentry';
import ROUTES from '../../../../../../constants/routes';

import { ISelectEventItem } from './interfaces';
import { useMytaverse } from '../../../../../../providers/MytaverseProvider';
import { createHashFromToken } from '../../../../../../helpers/externalUrlHash';
import { AnalyticsType } from '../../../../../../interfaces/analytics';

const SelectEventItem = ({
  event,
  eventsCount,
}: ISelectEventItem & { eventsCount: number }) => {
  const navigate = useNavigate();
  const { token, trackAnalytics } = useMytaverse();

  const isExternalEvent = useMemo(
    () => event?.eventTags && event?.eventTags.indexOf('External') > -1,
    [event],
  );

  const handleClick = useCallback(async () => {
    sendCustomSentryBreadcrumb({ message: `select event "${event.name}"` });

    trackAnalytics(AnalyticsType.EventSelect, {
      eventId: event.eventId,
    });

    if (isExternalEvent && event.externalUrl) {
      const hashedToken = await createHashFromToken(token);

      window.location.href = [
        event.externalUrl,
        event.externalUrl.includes('?') ? '&' : '?',
        `authHash=${hashedToken}`,
      ].join('');
    } else {
      navigate(ROUTES.AVATAR_CHOOSING(event.eventId));
    }
  }, [trackAnalytics]);

  return (
    <SelectEventItemView
      event={event}
      eventsCount={eventsCount}
      onClick={handleClick}
    />
  );
};

export default SelectEventItem;
